import React from "react";
import { useAppSelector } from "hooks/redux";
import { websiteBuilderHeadingRichTextExtensions } from "pages/secure/facility/websiteBuilder/editor/richText/extensions/websiteBuilderRichTextExtensions";
import { WebsiteBuilderRichTextBuilder } from "pages/secure/facility/websiteBuilder/editor/richText/WebsiteBuilderRichTextBuilder";
import { WebsiteBuilderRichTextStatic } from "pages/secure/facility/websiteBuilder/editor/richText/rendering/WebsiteBuilderRichTextStatic";
import {
  IWebsiteBuilderHeading,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderHeading";

interface IWebsiteBuilderHeadingViewProps {
  node: IWebsiteBuilderHeading;
  elementBuilderUIPortalId: string;
  sectionId: string;
}

export function WebsiteBuilderHeadingView(props: IWebsiteBuilderHeadingViewProps) {
  const { node, elementBuilderUIPortalId } = props;

  const selectedNode = useAppSelector(store => store.websiteBuilderStore.editor.selectedNode);

  const selected = selectedNode?.id === node.id;
  const builderActive = selected && selectedNode?.editingMode?.type === "element-builder";

  if (builderActive) {
    return (
      <WebsiteBuilderRichTextBuilder
        id={node.id}
        type={node.element.type}
        content={node.element.settings.content}
        extensions={websiteBuilderHeadingRichTextExtensions}
        elementBuilderUIPortalId={elementBuilderUIPortalId}
        sectionId={props.sectionId}
      />
    );
  } else {
    return (
      <WebsiteBuilderRichTextStatic content={node.element.settings.content} extensions={websiteBuilderHeadingRichTextExtensions} />
    );
  }
}
